import { Chip, styled } from '@ethings/ui-toolkit';
import { FC } from 'react';

export type LoanStatusColor = 'success' | 'warning' | 'error' | 'default';

interface LoanStatusChipProps {
  color: LoanStatusColor;
  status: string;
  fullWidth?: boolean;
}

interface StyledChipProps {
  fullWidth?: boolean;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ theme, fullWidth }) => ({
  height: 'auto',
  minWidth: 100,
  '& .MuiChip-label': {
    display: 'block',
    whiteSpace: 'normal',
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  ...(fullWidth ? { width: '100%' } : undefined),
}));

export const LoanStatusChip: FC<LoanStatusChipProps> = ({ status, color, fullWidth }) => {
  return (
    <StyledChip
      data-testid="loan-status-chip"
      color={color}
      label={status}
      fullWidth={fullWidth}
    />
  );
};
